function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.505",
  height: "17.662"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4766",
  "data-name": "Group 4766",
  fill: "#f5f5f5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2551",
  "data-name": "Path 2551",
  d: "M18.093 5.285v8.874H2.411V5.285H0v11.286h20.5V5.285z",
  transform: "translate(0 1.09)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2552",
  "data-name": "Path 2552",
  d: "M7.91 0v5.77h-2.4l3.609 6.248 3.606-6.248h-2.4V0z",
  transform: "translate(1.135)"
}))));